async function request(method, url, body, options = {}) {
    const headers = new Headers();
    headers.set('Content-Type', 'application/ld+json');
    headers.set('Accept', 'application/ld+json');

    if (options.headers) {
        new Headers(options.headers).forEach((value, key) => {
            headers.set(key, value);
        });
    }

    let fullUrl = url;
    if (options.params) {
        fullUrl = `${url}?${new URLSearchParams(options.params)}`;
    }

    const fetchOptions = { method, headers };
    if (body !== undefined) {
        fetchOptions.body = JSON.stringify(body);
    }

    const response = await fetch(fullUrl, fetchOptions);
    const contentType = response.headers.get('Content-Type') || '';
    const data = contentType.includes('json') ? await response.json() : await response.text();

    if (!response.ok) {
        const error = new Error(`HTTP ${response.status}`);
        error.response = { data, status: response.status };
        throw error;
    }

    return { data };
}

export default {
    get: (url, options) => request('GET', url, undefined, options),
    post: (url, body, options) => request('POST', url, body, options),
    patch: (url, body, options) => request('PATCH', url, body, options),
};
